import { Box, SxProps, Theme } from "@mui/material";
import { Fragment, ReactNode } from "react";
import { FONT_UI } from "@/src/components/common/broadsheet/tokens";

export default function MetaLine({
  items,
  separator = "·",
  sx,
}: {
  items: ReactNode[];
  separator?: string;
  sx?: SxProps<Theme>;
}) {
  const present = items.filter(
    (item) =>
      item !== null && item !== undefined && item !== false && item !== "",
  );

  if (present.length === 0) return null;

  return (
    <Box
      sx={[
        {
          fontFamily: FONT_UI,
          fontSize: "0.71875rem",
          lineHeight: 1.6,
          color: "custom.subtitleText",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "baseline",
          columnGap: 0.4,
          rowGap: 0.1,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {present.map((item, index) => (
        <Fragment key={index}>
          {index > 0 ? (
            <Box component="span" aria-hidden="true" sx={{ opacity: 0.55 }}>
              {separator}
            </Box>
          ) : null}
          <Box component="span">{item}</Box>
        </Fragment>
      ))}
    </Box>
  );
}
